// @flow
import React from 'react'

export default props => {
  const pathProps = props.pathProps || {}
  const svgProps = props.svgProps || {}
  return (
    <svg width="20px" height="16px" viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-374.000000, -248.000000)" fill="#DAE0E6">
          <g transform="translate(112.000000, 80.000000)">
            <g transform="translate(24.000000, 152.000000)">
              <path
                d="M250.001921,23.9982708 L250,23.9982708 L250,32 L258,32 L258,23.9982708 L253.557476,23.9982708 L258,16 L254.444444,16 L250.001921,23.9982708 Z M238.001921,23.9982708 L238,23.9982708 L238,32 L246,32 L246,23.9982708 L241.557476,23.9982708 L246,16 L242.444444,16 L238.001921,23.9982708 Z"
                {...pathProps}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
